export const SET_SUBSCRIPTIONS = "SET_SUBSCRIPTIONS";
export const CLEAR_SUBSCRIPTIONS = "CLEAR_SUBSCRIPTIONS";

export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const UPDATE_SUBSCRIPTION_SUCCESS = "UPDATE_SUBSCRIPTION_SUCCESS";
